import defaultFull from '@/layout/defaultFull'
// 发起的项目
const ProjectManageRouter = {
    path: '/project_manage_full', 
    name: 'project_manage_full',
    component: defaultFull,
    children: [
        {
            path: 'settlement', 
            name: 'op_settlement',
            children: [
                {
                    path: 'index/:id', // 结算管理
                    name: '结算管理',
                    component: () => import('@/views/project_manage/settlement/index/_id.vue')
                },
                {
                    path: 'apply/:preview/:period/:id', // 项目结算单
                    name: '项目结算单',
                    component: () => import('@/views/project_manage/settlement/apply/_id.vue')
                },
                {
                    path: 'rate/:id', // 结算费率
                    name: '结算费率',
                    component: () => import('@/views/project_manage/settlement/rate/_id.vue')
                }
            ]
        },
        {
          path: 'order/:id', // 订单管理
            name: 'op_order',
          component: () => import('@/views/project_manage/order/_id.vue'),
        },
        // {
        //     path: 'apply/:preview/:period/:id', // 项目结算单
        //     name: '项目结算单',
        //     component: () => import('@/views/project_manage/settlement/apply/_id.vue')
        // },
        {
            path: 'question/:id', // 常见问题
            name: 'op_question',
            component: () => import('@/views/project_manage/question/_id.vue')
        },
        {
            path: 'link/:id', // 项目宣传链接
            name: 'op_link',
            component: () => import('@/views/project_manage/link/_id.vue')
        },
        {
            path: 'analysis/:id', // 数据分析
            name: 'op_analysis',
            component: () => import('@/views/project_manage/analysis/_id.vue')
        },
        {
          path: 'deliver/:id', // 发货管理
            name: 'op_deliver',
          component: () => import('@/views/project_manage/deliver/_id.vue')
        },
        // {
        //     path: 'update', 
        //     name: 'update',
        //     children: [{
        //         path: 'index/:id',
        //         name: 'update-index',
        //         meta: {title: '项目更新'},
        //         component: () => import('@/views/project_manage/update/_id.vue')
        //     },{
        //         path: 'release_update',
        //         name: 'release_update',
        //         meta: {title: '创建更新'},
        //         component: () => import('@/views/project_manage/update/index.vue'),
        //     },{
        //         path: 'update_rule',
        //         name: 'update_rule',
        //         meta: {title: '违规提示'},
        //         component: () => import('@/views/project_manage/update/update_rule.vue'),
        //     },{
        //         path: 'update_list',
        //         name: 'update_list',
        //         meta: {title: '历史更新'},
        //         component: () => import('@/views/project_manage/update/update_list.vue'),
        //     },{
        //         path: 'draft_list',
        //         name: 'draft_list',
        //         meta: {title: '草稿箱'},
        //         component: () => import('@/views/project_manage/update/draft_list.vue'),
        //     },{
        //         path: 'pre_list',
        //         name: 'pre_list',
        //         meta: {title: '待发布'},
        //         component: () => import('@/views/project_manage/update/pre_list.vue'),
        //     }]
        // },
        {
            path: 'after_sale/:id', // 售后管理
            name: 'op_after_sale',
            meta: {title: '售后管理'},
            component: () => import('@/views/project_manage/after_sale/_id.vue')
        },
        {
            path: 'complain_manage/:id', // 工单管理
            name: 'op_complain_manage',
            meta: {title: '工单管理'},
            component: () => import('@/views/project_manage/complain_manage/_id.vue')
        },
        {
            path: 'supplemental_agreement/:id', // 上传补充文件
            name: 'op_supplemental_agreement',
            meta: {title: '上传补充文件'},
            component: () => import('@/views/project_manage/supplemental_agreement/_id.vue')
        }
    ]
}

export default ProjectManageRouter
